import type { IMenuLinks, ISubMenu, ISubMenuLinks } from "./VNavigation.types";

export enum MenuItems {
  APTEKA = "apteka",
  COSMETIC = "cosmetic",
  MARKET = "market",
  MAGNIT = "magnit",
}

export const MENU_LINKS: IMenuLinks = [
  {
    label: "Магнит",
    url: "https://magnit.ru",
    name: MenuItems.MAGNIT,
    color: "#ed0e00",
  },
  {
    label: "Косметик",
    url: "https://cosmetic.magnit.ru",
    name: MenuItems.COSMETIC,
    color: "#e0016c",
  },
  {
    label: "Аптека",
    url: "https://apteka.magnit.ru",
    name: MenuItems.APTEKA,
    color: "#1598a6",
  },
  {
    label: "Магнит Маркет",
    url: "https://mm.ru",
    name: MenuItems.MARKET,
    color: "#ff462d",
  },
];

export const CLIENT_LINKS: ISubMenu = {
  title: "Покупателям",
  links: [
    {
      label: "Карта Магнит Плюс",
      url: `https://magnit.ru/mplus`,
      rel: "noreferrer",
    },
    {
      label: "Промокоды Доставки",
      url: `https://promo.magnit.ru`,
    },
    {
      label: "Бонусы от партнёров",
      url: `https://magnit.ru/partners`,
      rel: "noreferrer",
    },
    {
      label: "Помощь",
      url: "https://magnit.ru/faq",
      rel: "noreferrer",
    },
    {
      label: "Гастроном",
      url: "https://gastronom.ru",
    },
  ],
};

export const MANAGEMENT_LINKS: ISubMenu = {
  title: "Сотрудничество",
  links: [
    {
      label: "Партнёрам",
      url: "https://b2b.magnit.ru",
      rel: "noreferrer",
    },
    {
      label: "Акционерам и инвесторам",
      url: "https://www.magnit.com/ru/shareholders-and-investors/investment-case",
    },
    {
      label: "О компании",
      url: "https://www.magnit.com/ru",
    },
    {
      label: "Вакансии",
      url: "https://magnit.ru/vacancies",
    },
  ],
};

export const COMPANY_LINKS: ISubMenu = {
  title: "Правовая информация",
  links: [
    {
      label: "Условия проведения акций",
      url: "https://magnit.ru/promo_rules",
      rel: "noreferrer",
    },
    {
      label: "Правила программы лояльности",
      url: "https://magnit.ru/terms",
      rel: "noreferrer",
    },
    {
      label: "Политика конфиденциальности",
      url: "https://magnit.ru/pdn",
      rel: "noreferrer",
    },
    {
      label: "Антикоррупционная горячая линия",
      url: "https://www.magnit.com/ru/anti-corruption",
    },
    {
      label: "Реквизиты АО «Тандер»",
      url: "https://magnit.ru/tander",
      rel: "noreferrer",
    },
  ],
};

export const SUBMENU_LINKS: ISubMenuLinks = [
  CLIENT_LINKS,
  MANAGEMENT_LINKS,
  COMPANY_LINKS,
];
